import { EMPTY_ROOT_CONTAINER_PROPS_WITH_API } from "@client/content/lib/consts";
import { getEntityRef } from "@client/content/lib/helper";
import { makeModuleApiInfoSelector } from "@client/content/selectors";
import { type RootContainerProps } from "@client/content/types";
import { connectCustom } from "@client/lib/misc";
import { type AppState, type Common } from "@client/types";
import { setShowingModal, updateProfilePicture } from "../../actions";
import { localStateSelector } from "../../selectors";
import Component, { type ActionProps, type MapProps } from "./component";

const INVISIBLE_PROPS: MapProps = {
  ...EMPTY_ROOT_CONTAINER_PROPS_WITH_API,
  allowUploadProfilePicture: false,

  isVisible: false,
  item: {
    type: "incentive",
    countryName: "",
    date: "",
    displayName: "",
    email: "",
    firstName: "",
    lastName: "",
    id: "",
    rewardId: "",
    movement: 0,
    position: 0,
    profilePictureMediaId: "",
    profilePictureMediaSourceKey: "AwsS3",
    profilePictureSourceId: "",
    profilePictureMediaUrl: "",
    requiredScore: 0,
    userId: -1,
    score: 0
  },
  mediaId: "",
  portalId: ""
};
const makeMapStateToProps = () => {
  const apiInfoSelector = makeModuleApiInfoSelector();

  return (state: AppState, props: RootContainerProps): MapProps => {
    const localState = localStateSelector(state, props);

    if (localState.showingModal?.type !== "Profile") return INVISIBLE_PROPS;

    return {
      allowUploadProfilePicture: localState.allowUploadProfilePicture,
      apiInfo: apiInfoSelector(state, props),
      id: props.id,

      item: localState.current!,
      mediaId: localState.source!.joinedVideoMediaId,
      isVisible: true,
      portalId: state.portal.id
    };
  };
};

const mapDispatchToProps = (dispatch: any, props: RootContainerProps): ActionProps => ({
  onClose: () => dispatch(setShowingModal(getEntityRef(props), null)),
  onProfilePictureUploaded: (media: Common.Media | null) => dispatch(updateProfilePicture(getEntityRef(props), media))
});

export default connectCustom(makeMapStateToProps, mapDispatchToProps)(Component);
